import Vue from 'vue';
import store from './../../store';
import countryTransformer from './../../transformers/country';

const success = ({ data }, resolve) => {
  const countries = countryTransformer.fetchCollection(data.data);
  const pagination = countryTransformer.fetch(data.pagination);
  store.dispatch('fetchCountries', { countries, pagination });

  resolve();
};

const failed = (error, reject) => reject(error);


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('countries')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/country/all.js